import { combineReducers } from 'redux';
import onboarding from './onboarding';
import profile from './profile';
import register from './register';
import { StateAuthType } from './types';

const reducer = combineReducers<StateAuthType>({ register, onboarding, profile });

export default reducer;
